export const PERSONAL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "aol.com",
  "icloud.com",
  "protonmail.com",
  "zoho.com",
  "gmx.com",
  "yandex.com",
];

export const COMPANY_SIZE_MAP: Record<string, string> = {
  just_me: "Just me",
  startup: "2–10",
  small_company: "11–50",
  medium_company: "51–200",
  large_company: "201–1,000",
  enterprise_company: "1,000+",
};

export const COMPANY_SIZES = [
  { title: "Just me", value: "just_me" },
  { title: "2–10", value: "startup" },
  { title: "11–50", value: "small_company" },
  { title: "51–200", value: "medium_company" },
  { title: "201–1,000", value: "large_company" },
  { title: "1,000+", value: "enterprise_company" },
] as const;

export const ONBOARDING_ROLES = [
  { title: "Prompt Engineer", description: "Design prompts", value: "prompt_engineer" },
  { title: "Developer", description: "Build with SDKs", value: "developer" },
  { title: "Founder / Executive", description: "Lead the strategy", value: "founder_executive" },
  { title: "Product", description: "Shape workflows", value: "product" },
  { title: "Data / ML", description: "Evaluate systems", value: "data_ml" },
  { title: "Other", description: "Something else", value: "other" },
] as const;

export const ROLES = ONBOARDING_ROLES.map(role => ({
  title: role.title,
  value: role.value,
  id: role.value,
}));
